import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface AnalyticsEvent {
  event_name: string;
  event_data?: Record<string, any>;
  user_id?: string;
}

class AnalyticsService {
  private queue: AnalyticsEvent[] = [];
  private flushInterval: number = 30000; // 30 seconds
  private maxQueueSize: number = 10;

  constructor() {
    // Flush queue periodically
    setInterval(() => this.flush(), this.flushInterval);

    // Flush on page unload
    window.addEventListener('beforeunload', () => this.flush());
  }

  async track(eventName: string, eventData?: Record<string, any>) {
    const { data } = await supabase.auth.getUser();
    const event: AnalyticsEvent = {
      event_name: eventName,
      event_data: eventData,
      user_id: data.user?.id
    };

    this.queue.push(event);

    if (this.queue.length >= this.maxQueueSize) {
      this.flush();
    }
  }

  private async flush() {
    if (this.queue.length === 0) return;

    const events = [...this.queue];
    this.queue = [];

    try {
      // In production, send to analytics service
      // Example: await fetch('/api/analytics', { method: 'POST', body: JSON.stringify(events) });
    } catch (error) {
      console.error('[Analytics] Failed to flush events:', error);
      // Re-queue events on failure
      this.queue.unshift(...events);
    }
  }
}

export const analytics = new AnalyticsService();

export const UsageAnalytics = () => {
  useEffect(() => {
    // Track page views
    analytics.track('page_view', {
      path: window.location.pathname,
      timestamp: Date.now()
    });

    // Track engagement time
    const startTime = Date.now();
    return () => {
      const engagementTime = Date.now() - startTime;
      analytics.track('engagement_time', {
        path: window.location.pathname,
        duration: engagementTime
      });
    };
  }, []);

  return null;
};
